import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
import usePerformanceOptimization from '../../hooks/usePerformanceOptimization';

const Section = ({
  children,
  className = '',
  containerClassName = '',
  background = '',
  padding = 'py-16',
  animate = false,
  id,
  ...props
}) => {
  const { shouldReduceAnimations, getOptimizedProps } = usePerformanceOptimization();

  const sectionVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const SectionComponent = animate && !shouldReduceAnimations ? motion.section : 'section';
  const animationProps = animate && !shouldReduceAnimations 
    ? getOptimizedProps({
        variants: sectionVariants,
        initial: "initial",
        whileInView: "animate",
        viewport: { once: true, margin: "-100px" }
      })
    : {};

  return (
    <SectionComponent
      id={id}
      className={cn(padding, background, className)}
      {...animationProps}
      {...props}
    >
      <div className={cn('max-w-7xl mx-auto px-4 sm:px-6 lg:px-8', containerClassName)}>
        {children}
      </div>
    </SectionComponent>
  );
};

export default Section;